<div class="container {{ OBJ_LNG_NAME }} insertEdit">
  <div class="dialog-header">
    <h1 mat-dialog-title>
      {{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
      <mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
    </h1>
    <button mat-icon-button type="button" mat-dialog-close class="close-button"><mat-icon aria-label="Schließen">close</mat-icon></button>
  </div>
  <mat-dialog-content>
    <form #inserteditForm="ngForm" class="{{ OBJ_LNG_NAME }} inserteditForm">

      <p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>

      <mat-form-field class="full-width">
        <input matInput #login="ngModel" [(ngModel)]="aktuell.login" name="login" class="full-width" maxlength="255"
          required [disabled]="dialogrunningajaxcall" />
        <mat-label>{{ OBJ_LNG_NAME + '.login' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="login.errors && (login.dirty || login.touched) && login.errors.required">{{
          'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.login' |
          translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="login.value" align="end">{{ login.value.length }} / 255</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width" [class.ng-invalid]="aktuell.passwortwiederholung != aktuell.passwort"
        [class.ng-valid]="aktuell.passwortwiederholung == aktuell.passwort">
        <input matInput #passwort="ngModel" [(ngModel)]="aktuell.passwort" name="passwort" class="full-width"
          maxlength="255" type="password" [required]="neu" [disabled]="dialogrunningajaxcall" />
        <mat-label>{{ (neu ? OBJ_LNG_NAME + '.passwort' : OBJ_LNG_NAME + '.passwortneu') | translate:locale.language
          }}</mat-label>
        <mat-hint *ngIf="aktuell.passwort != passwortwiederholung.value">{{ 'allgemein.validierung.nichtgleich' |
          translate:locale.language:{ typ: (neu ? OBJ_LNG_NAME + '.passwort' : OBJ_LNG_NAME + '.passwortneu') |
          translate:locale.language, typvergl: OBJ_LNG_NAME + '.passwortwiederholung' | translate:locale.language }
          }}</mat-hint>
        <mat-hint class="pwdhint" *ngIf="aktuell.passwort" align="end">
          <ngx-password-strength-bar *ngIf="aktuell.passwort" [passwordToCheck]="aktuell.passwort"
            [barLabel]="getPasswortStaerke(aktuell.passwort)"></ngx-password-strength-bar>
        </mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width" [class.ng-invalid]="aktuell.passwortwiederholung != aktuell.passwort"
        [class.ng-valid]="aktuell.passwortwiederholung == aktuell.passwort">
        <input matInput #passwortwiederholung="ngModel" [(ngModel)]="aktuell.passwortwiederholung"
          name="passwortwiederholung" class="full-width" maxlength="255" type="password" [required]="neu"
          [disabled]="dialogrunningajaxcall" />
        <mat-label>{{ OBJ_LNG_NAME + '.passwortwiederholung' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="aktuell.passwortwiederholung != aktuell.passwort">{{ 'allgemein.validierung.nichtgleich' |
          translate:locale.language:{ typ: OBJ_LNG_NAME + '.passwortwiederholung' | translate:locale.language, typvergl:
          (neu ? OBJ_LNG_NAME + '.passwort' : OBJ_LNG_NAME + '.passwortneu') | translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="passwortwiederholung.value" align="end">{{ passwortwiederholung.value.length }} /
          255</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput #name="ngModel" [(ngModel)]="aktuell.name" name="name" class="full-width" maxlength="255"
          required [disabled]="dialogrunningajaxcall" />
        <mat-label>{{ OBJ_LNG_NAME + '.name' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="name.errors && (name.dirty || name.touched) && name.errors.required">{{
          'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.name' |
          translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="name.value" align="end">{{ name.value.length }} / 255</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput #email="ngModel" [(ngModel)]="aktuell.email" name="email" class="full-width" minlength="6"
          maxlength="255" type="email" pattern="[A-Z0-9a-z\._%\+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,64}"
          [disabled]="dialogrunningajaxcall" />
        <mat-label>{{ OBJ_LNG_NAME + '.email' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="email.errors && (email.dirty || email.touched) && email.errors.required">{{
          'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.email' |
          translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="email.errors && (email.dirty || email.touched) && email.errors.pattern">{{
          'allgemein.validierung.formatfalsch' | translate:locale.language }}</mat-hint>
        <mat-hint *ngIf="email.value" align="end">{{ email.value.length }} / 255</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width" *ngIf="aktuell.kerngruppenAlle != null && aktuell.kerngruppenAlle.length > 0">
        <mat-select multiple="true" name="kerngruppen" [compareWith]="compareMitId" [(ngModel)]="aktuell.kernGruppen"
          placeholder="{{ 'allgemein.auswählen' | translate:locale.language:{ typ: 'kerngruppe.typen' | translate:locale.language } }}">
          <mat-option *ngFor="let i of aktuell.kerngruppenAlle" [value]="i">{{ 'kerngruppe.' + i.sprachschluessel |
            translate:locale.language }}</mat-option>
        </mat-select>
        <mat-label>{{ OBJ_LNG_NAME + '.kerngruppe' | translate:locale.language }}</mat-label>
      </mat-form-field>

      <mat-slide-toggle color="primary" name="aktiv" [(ngModel)]="aktuell.aktiv" [disabled]="dialogrunningajaxcall">{{
        OBJ_LNG_NAME + '.status' | translate:locale.language }}</mat-slide-toggle>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <button mat-raised-button type="button" (click)="close()" [disabled]="dialogrunningajaxcall">{{
      'allgemein.abbrechen' | translate:locale.language }}</button>
    <button mat-raised-button type="submit" (click)="speichernAendern()" color="primary"
      [disabled]="!inserteditForm.form.valid || dialogrunningajaxcall">
      <mat-spinner *ngIf="dialogrunningajaxcall"></mat-spinner>
      {{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : (neu ? 'allgemein.neu' : 'allgemein.speichern')) |
      translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
    </button>

  </mat-dialog-actions>
</div>